import { IIndicatorsLevel } from "../interface";

export interface IRefActionsModalChartIndicators{
    actionButtonOpenChartIndicators: (id: number, title: string, baseYear: string, showAccumulatedValues: boolean, startDate?: Date | null, endDate?: Date | null) => void;
}

export interface IModalIndicatorChart{
    openValuesOfPeriodIndicator: (id: number, title: string, periodId: number, onCallback?: Function, isPresentation?: boolean) => void;
    onCloseCallback: () => void;
}

export interface IChartValuesIndicators{
    periodId: number;
    name: string;
    value: number;
    chartType: IChartTypeIndicator;
    showInChart: boolean;
    showInTable: boolean;
    labelCode: string;
    currentPeriod: string;
    hasFca: boolean;
    fcaAbsent: boolean;
    showLabel: boolean;
    axisY: IChartIndicatorsAxisY;
    color: string | null;
    fieldColor: string | null;
    comment?: string | null;
    indicatorGoalType: IndicatorGoalType;
    isTendency: boolean | null;
    decimalPlaces?: number;
}

export interface IConfigsShowGoal{
    showGoalImprovementInGraphic?: boolean;
    showGoalCompetitivenessInGraphic?: boolean;
    showGoalCommitmentInGraphic?: boolean;
}

export interface IChartIndicators{
    name: string;
    hasFCA: boolean;
    [key: string]: number | string | any[] | any;
}

export interface IChartDataIndicators{
    name: string;
    order?: number;
    hasFCA: boolean;
    values: IChartValuesIndicators[];
}

export interface IChartTableIndicatorsValues{
    name: string;
    value: number;
    labelCode: string;
    currentPeriod: string;
    hasFca?: boolean;
    showFCAHeader?: boolean;
    fcaAbsent: boolean;
    comment: string | null;
    periodId?: number;
    decimalPlaces?: number;
}

export interface IChartTableIndicators{
    name: string;
    values: IChartTableIndicatorsValues[];
    accumulatedValues?: IChartTableIndicatorsValues[];
    isTendency: boolean | null;
}

export enum IndicatorGoalType{
    IMPROVEMENT = "S",
    COMMITMENT = "O",
    COMPETITIVENESS = "C",
    NOT_A_GOAL = "N"  
}

export enum IChartIndicatorsAxisY{
    LEFT = 1,
    RIGHT = 2
}

export enum IChartTypeIndicator{
    LINE = 1,
    BAR = 2,
    AREA = 3
}

export interface IFieldsChart{
    dataKey: string;
    chartType: IChartTypeIndicator;
    showLabel: boolean;
    colorIndex: number;
    customColorForEachBarOfSameData?: boolean;
    fieldColor: string | null;
    axisRight: boolean;
    decimalPlaces?: number;
}

export interface IListForChartModalIndicatorsComponent{
    data: IChartTableIndicators[]; 
    showAccumulatedValues: boolean;
    onClickChartAreaBarLine?: (periodId: number, isPresentation: boolean) => void;
}

export enum IChartColorIndicators{
    METRICS = 1,
    LEGEND = 2
}

export enum IChartCompIndicators{
    SIDE_BY_SIDE = 1,
    STACKED = 2
}

export enum IChartLabelIndicators{
    HORIZONTAL = 1,
    VERTICAL = 2
}

export interface IChartConfigIndicators{
    iqc001Ocultarformaaval: boolean;
    iqc001Formaaval: number;
    iqc001Metodo: string | null;
    iqc001Descobjetivo: string;
    iqc001Taa009Descricao: string;
    iqc001Nivel: IIndicatorsLevel;
    years: string[];

    iqc001Escalamin: number | null;  
    iqc001Escalamax: number | null;  
    iqc001Corgrafico: IChartColorIndicators;
    iqc001Compgrafico: IChartCompIndicators;
    iqc001Roteixoesq: string | null; 
    iqc001Roteixodir: string | null;  
    iqc001Escalamindir: number | null; 
    iqc001Escalamaxdir: number | null; 
    iqc001Labelvalores: IChartLabelIndicators;
    iqc001Paletacores: number;

    showAll?: boolean;

    startDate?: Date | null;
    endDate?: Date | null;
}

export interface IComment{
    name: string;
    text: string
}

export interface IConfigsChartModal{
    leftAxisYMin?: number;
    leftAxisYMax?: number;
    rightAxisYMin?: number;
    rightAxisYMax?: number;
    showValues: "1" | "2" | "3";
}
